import axios from 'axios'
import { RECUPERAR_VALOR_PRECO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function recuperarValorPrecoIdaVolta (preco) {
  const urlBase = `${URL}/preco/recuperar/valor`;

  const url = `${urlBase}?empresaId=${preco.empresaId}&cidadeOrigemId=${preco.cidadeOrigemId}
                    &cidadeDestinoId=${preco.cidadeDestinoId}&tipoPreco=${preco.tipoPreco}`

  return dispatch => axios.get(url , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: RECUPERAR_VALOR_PRECO,
        payload: response
      })
  );
}
